import { defineStore } from 'pinia'
import type { Team } from '~/types/team'

export const useTeamStore = defineStore('team', {
    state: () => ({
        teams: [] as Team[],
        teamsLoaded: false
    }),

    actions: {
        async setTeams(teams: Team[]) {
            this.teams = teams
        },

        async init() {
            await this.fetchTeams();
        },

        async fetchTeams(force = false) {
            if (this.teamsLoaded && !force) return

            const { $api } = useNuxtApp();
            await $api.get(`/teams`).then((response) => {
                this.teams = response.data
            });
        },

        clear() {
            this.teams = []
        }
    }
})